import { render, staticRenderFns } from "./PlusGradient.vue?vue&type=template&id=2e6f3ba9"
import script from "./PlusGradient.vue?vue&type=script&lang=js"
export * from "./PlusGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports